
export const appInfo = {
    name: 'ERP Toàn Hằng',
    ename: 'toanhangdn',
    version: '1.0.0', // needs to be in sync with version in package.json
    debugMode: process && process.env && process.env.NODE_ENV !== 'production'
};